import { render } from "./ListaContratacoesVigentesView.vue?vue&type=template&id=413dddcb&scoped=true"
import script from "./ListaContratacoesVigentesView.vue?vue&type=script&lang=js"
export * from "./ListaContratacoesVigentesView.vue?vue&type=script&lang=js"

import "./ListaContratacoesVigentesView.vue?vue&type=style&index=0&id=413dddcb&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-413dddcb"]])

export default __exports__